module.exports = __webpack_public_path__ + "img/healthcare.f7502b18.jpg";